module.exports = __webpack_public_path__ + "img/space_food_sticks_ad_1971.3f9c960b.jpg";